import React, { FC, PropsWithChildren, useEffect } from 'react';
import { useTrack } from '@splitsoftware/splitio-react';

import { SPLIT_LOCAL_STORAGE_KEY, SplitEventData } from './actionTypes';

//  This component allows us to track clicks on a link. Just set event data to the localStorage before navigating.
export const SplitLocalStorageEventsSender: FC<PropsWithChildren> = ({
  children,
}) => {
  const splitTrack = useTrack();

  useEffect(() => {
    if (!window.splitFactory || !SPLIT_LOCAL_STORAGE_KEY) {
      return;
    }

    for (const localStorageKey of Object.values(SPLIT_LOCAL_STORAGE_KEY)) {
      const eventData = localStorage.getItem(localStorageKey);
      if (!eventData) {
        continue;
      }
      // TODO: refactor without type assertion, or add comment
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      const { eventType, value, properties } = JSON.parse(
        eventData,
      ) as SplitEventData;
      const addedToQueue = splitTrack('user', eventType, value, properties);
      if (addedToQueue) {
        localStorage.removeItem(localStorageKey);
      }
    }
  }, [window.splitFactory]);

  //@ts-ignore
  return <>{children}</>;
};
